// Holdings del operador (contracts: identidad y membresía) con el estado del "Cobro
// consolidado" (billing: perfil de cobro de cada holding). Cada parte la sirve su dueño; acá solo
// se combinan para la pantalla.
//
// Lo usan el asistente de cobro (solo ofrece los holdings ENCENDIDOS y solo esos absorben a sus
// empresas), la lista de Holdings de Empresas y el aviso de la tarifa de una empresa de holding.

import { listOperatorHoldings } from '../../../../api/operatorHoldings';
import { listHoldingProfiles } from '../../../../api/collections';
import { withConsolidation } from './holdings';

/**
 * @returns {Promise<{ holdings: object[], consolidationError: unknown|null }>}
 *   `holdings` son los de GET contracts/holdings, cada uno con `consolidatedEnabled` y
 *   `consolidatedEnabledAt`. Si falla la lectura de billing, `consolidationError` trae el error
 *   y los holdings vuelven SIN esos campos (estado desconocido): quien llama decide cómo
 *   degradar. Lanza si falla contracts o su respuesta no es una lista.
 *
 *   Sin holdings no se consulta a billing: la mayoría de los operadores no tiene ninguno.
 */
export async function loadHoldingsWithConsolidation() {
  const res = await listOperatorHoldings();
  if (!Array.isArray(res?.data)) throw new Error('Respuesta inesperada de contracts/holdings');
  if (res.data.length === 0) return { holdings: [], consolidationError: null };
  try {
    const { data } = await listHoldingProfiles();
    if (!Array.isArray(data?.items)) {
      throw new Error('Respuesta inesperada de billing/collections/holding-profiles');
    }
    return { holdings: withConsolidation(res.data, data.items), consolidationError: null };
  } catch (consolidationError) {
    return { holdings: res.data, consolidationError };
  }
}
